const DARK = "#0a0a0a";
const LIGHT = "#ffffff";

/**
 * Text color for a label sitting on `fill` (a `#rgb` or `#rrggbb` brand
 * color): whichever of near-black or white has the higher WCAG contrast.
 * Anything unreadable falls back to near-black, which suits AuthenSee orange.
 */
export function readableTextOn(fill: string | undefined): typeof DARK | typeof LIGHT {
  const hex = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(fill ?? "")?.[1];
  if (!hex) return DARK;
  const full = hex.length === 3 ? [...hex].map((c) => c + c).join("") : hex;
  const channel = (i: number) => {
    const c = parseInt(full.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const luminance = 0.2126 * channel(0) + 0.7152 * channel(2) + 0.0722 * channel(4);
  // Contrast against black is (L + 0.05) / 0.05; against white 1.05 / (L + 0.05).
  return (luminance + 0.05) / 0.05 >= 1.05 / (luminance + 0.05) ? DARK : LIGHT;
}
